import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React from 'react';

import { getUserAvatarThumb } from 'utilities/avatar';

import GetUserWithProfileInfo from '../../user-profile/profile-card/GetUserWithProfileInfo.graphql';

import ProfileCard from 'components/user-profile/profile-card';

import styles from './styles.module.less';

const propTypes = {
  teamMember: PropTypes.object,
  name: PropTypes.string.isRequired,
};

const MentionPill = ({ teamMember, name }) => {
  const { data: userProfileData } = useQuery(GetUserWithProfileInfo, {
    variables: {
      userId: teamMember?.id,
    },
    fetchPolicy: 'no-cache',
    skip: !teamMember,
  });

  if (!teamMember) {
    return <div className={styles.mention}>@{name}</div>;
  }

  const avatar = getUserAvatarThumb(teamMember.avatars);

  return (
    <div className={styles.mention}>
      <ProfileCard
        avatarSrc={avatar}
        name={name}
        profileId={teamMember.id}
        hasFocus
        useLoomSSRVideo={false}
        placement="top-center"
        cachedUserProfileData={userProfileData}
      >
        {name}
      </ProfileCard>
    </div>
  );
};

MentionPill.propTypes = propTypes;

export default MentionPill;
